import TransactionListOverview from "./TransactionsOverview/TransactionListOverview";
import SummaryBars from "./SummaryBars";
import { useRef, forwardRef, useImperativeHandle } from "react";

const cardStyleBase = {
    background: "white",
    margin: "30px",
    marginTop: "5px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    borderRadius: "10px"
};
const smallCardStyle = Object.assign({}, cardStyleBase, { width: "30%" });
const cardStyle = Object.assign({}, cardStyleBase, { width: "35%" });
const cardContainerStyle = Object.assign(
    {},
    {
        justifyContent: "center",
        display: "flex"
    }
);

export default forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setTransactionsItems: (items) => {
            setTransactionsItems(items);
        },
        setCategoryItems: (categoryData) => {
            setCategoryItems(categoryData);
        }
    }));

    const categoryItemsRef = useRef(null);
    const transactionListRef = useRef(null);

    const setTransactionsItems = (items) => {
        transactionListRef.current.setItems(items);
    };
    const setCategoryItems = (categoryData) => {
        categoryItemsRef.current.setItems(categoryData);
    };

    const categoryWasClicked = async (mode, categoryId, categoryDescription) => {
        transactionListRef.current.filterTransactionsByCategory(categoryId);
    };

    const categoryWasUnclicked = async () => {
        transactionListRef.current.clearFilters();
    };

    return (
        <div style={cardContainerStyle}>
            <div style={smallCardStyle}>
                <TransactionListOverview
                    transactionType={props.transactionType}
                    ref={transactionListRef}
                />
            </div>
            <div style={cardStyle}>
                <SummaryBars
                    mode={props.mode}
                    ref={categoryItemsRef}
                    categoryWasClicked={categoryWasClicked}
                    categoryWasUnclicked={categoryWasUnclicked}
                />
            </div>
        </div>
    );
});